/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Titlemaximum4Inputs */

const en_coinvestments_submitticketsize_modal_titlemaximum4 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Titlemaximum4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Max. Ticket Size" |
*
* @param {Coinvestments_Submitticketsize_Modal_Titlemaximum4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_titlemaximum4 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Titlemaximum4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Titlemaximum4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_titlemaximum4(inputs)
});
export { coinvestments_submitticketsize_modal_titlemaximum4 as "coInvestments_submitTicketSize_modal_titleMaximum" }